import styles from './autocomple.module.css'
import ClickAwayListener from '../ClickAwayLinstener'


const Autocomplete = {
    Container: ({ onClose, ...props }) => <ClickAwayListener onClickAway={onClose} className={styles.container} {...props} />,
    Popper: (props) => <div className={styles.popper} {...props} />
}

export default Autocomplete